import { Component, input, Input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  title: InputSignal<string> = input<string>();
}
